<template>
	<page gradient-background>
		<doc-base>
			<template #title>{{baseInfo.create_user_realname}}_加班申请</template>

			<template #info>
				<c-field label="单据编号">{{baseInfo.document_number}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="加班类型"><c-state dict="overtimeTypeDic" :value="baseInfo.overtime_type"></c-state></c-field>
			<c-field v-if="baseInfo.overtime_type == 1" label="关联工单"><c-link @click="mp.navigateWeb('/aftersales/work/detail', {id: baseInfo.order_id})">{{baseInfo.order_number}}</c-link></c-field>
			<c-field label="加班时间" vertical>
				<detail-card v-for="(item, i) in baseInfo.detail_list" :key="i" :index="i + 1">
					<c-field v-if="baseInfo.overtime_type == 1" label="加班人员">{{item.user_name}}</c-field>
					<c-field label="开始时间">{{item.start_date}}</c-field>
					<c-field label="结束时间">{{item.end_date}}</c-field>
					<c-field label="加班类型">
						<template v-for="(tag, j) in item.holiday_types">
							<span v-if="j">、</span>
							<c-state :key="j" dict="overtimeDayTypeDic" :value="tag"></c-state>
						</template>
					</c-field>
					<c-field label="加班时长"><b>{{item.overtime_duration}}小时</b></c-field>
				</detail-card>
			</c-field>
			<c-field label="加班事由">{{baseInfo.reason}}</c-field>
			<c-field label="凭证">
				<c-file-list :value="baseInfo.voucher_images"></c-file-list>
			</c-field>
		</doc-content>

		<doc-content v-if="baseInfo.status != -1 && baseInfo.overtime_type == 1" title="工单打卡记录">
			<c-empty v-if="!baseInfo.sign_list.length"></c-empty>
			<log-item v-for="(item, i) in baseInfo.sign_list" :key="i">
				<template>
					<p>{{item.create_date}} 由 <span>{{item.user_realname}}</span> <c-state dict="signTypeOptions" :value="item.sign_type" style="color: inherit"></c-state></p>
				</template>

				<template #remark>
					<c-field label="打卡地址">{{item.address_detail}}</c-field>
					<c-field label="备注">{{item.remark}}</c-field>
				</template>
			</log-item>
		</doc-content>

		<doc-log ref="docLog" :form-id="baseInfo.form_id"></doc-log>

		<doc-handle
			ref="docHandle"
			flow="6"
			:order="id"
			:status="baseInfo.status"
			:applicant="baseInfo.is_founder == 1"
			:approver="baseInfo.is_approval == 1"
			@edit="mp.navigateWeb('/affairs/overtime/edit', {id: baseInfo.id})"
			@delete="deleteHandle"
			@update="update"
		></doc-handle>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
				this.$refs.log.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/overtime/application/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, transaction}) => {
						this.baseInfo = detailInfo;
						this.$refs.docHandle.init(transaction);
					}
				});
			},

			deleteHandle() {
				this.$confirm({
					message: '确定要删除该单据吗',
					resolve: () => {
						this.request({
							url: '/overtime/application/delete',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								setTimeout(() => {
									this.mp.navigateBack();
								}, 1000);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>